import { Icon, type IIconProps, Tooltip } from 'shared/ui'
import { type CannedMessage } from 'entities/CannedMessages/model/CannedMessage'

export type IIconSharedSavedReplyProps = {
  savedReply?: CannedMessage | null
  className?: string
  iconProps?: IIconProps
}

export const IconSharedSavedReply = ({
  savedReply,
  className,
  iconProps,
}: IIconSharedSavedReplyProps) => {
  if (!savedReply) return null

  const isMySharedSavedReply = savedReply.public && savedReply.isMyReply
  const isTeammateSharedSavedReply = !savedReply.isMyReply && savedReply.public

  if (isMySharedSavedReply) {
    return (
      <Tooltip
        className={className}
        placement='top'
        label={'Shared by you and visible to all members'}
      >
        <Icon icon={'users'} tertiary fontSize={16} {...iconProps} />
      </Tooltip>
    )
  }

  if (isTeammateSharedSavedReply) {
    return (
      <Tooltip className={className} placement='top' label={'Shared by a teammate'}>
        <Icon icon={'forward'} tertiary fontSize={16} {...iconProps} />
      </Tooltip>
    )
  }
  return null
}
